module.exports = __webpack_public_path__ + "img/leasing-desktop-car.9b2607a.png";